import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-carbon-equivalence',
  templateUrl: './carbon-equivalence.component.html',
  styleUrl: './carbon-equivalence.component.scss',
  standalone: false,
})
export class CarbonEquivalenceComponent implements OnChanges {
  @Input() impactPerTraveller?: number;
  private _compareCar: Array<{
    name: string;
    ecv: string;
    icon: string;
    description: string;
    alt: string;
  }> = [];

  ngOnChanges() {
    if (this.impactPerTraveller) {
      this._compareCar = [
        {
          name: 'worldCar',
          ecv: this.resultCarbon(8704),
          icon: 'car',
          description: 'tour de la terre en voiture',
          alt: 'car',
        },
        {
          name: 'fridge',
          ecv: this.resultCarbon(338.7140334),
          icon: 'refrigerator',
          description: `refrigirateur`,
          alt: 'fridge',
        },
        {
          name: 'homeDelivery',
          ecv: this.resultCarbon(0.576),
          icon: 'package',
          description: 'Livraison à domicile',
          alt: 'door-to-door-delivery',
        },
        {
          name: 'jeans',
          ecv: this.resultCarbon(25.08872880618721),
          icon: 'shirt',
          description: 'jeans',
          alt: 'jeans',
        },
        {
          name: 'coffee',
          ecv: this.resultCarbon(0.635463),
          icon: 'coffee',
          description: 'litres de café',
          alt: 'cafe',
        },
        {
          name: 'pizza',
          ecv: this.resultCarbon(3.5994),
          icon: 'pizza',
          description: 'kg de pizza quatre fromages',
          alt: 'pizza',
        },
        {
          name: 'brownie',
          ecv: this.resultCarbon(8.3569),
          icon: 'cake-slice',
          description: 'kg de brownie au chocolat',
          alt: 'dessert',
        },
        {
          name: 'smartphone',
          ecv: this.resultCarbon(85.85),
          icon: 'smartphone',
          description: 'smartphone',
          alt: 'smartphone--v1',
        },
      ].filter((category) => category.ecv !== '0');
    } else {
      this._compareCar = [];
    }
  }

  get kgTotal(): string {
    return (this.impactPerTraveller || 0).toLocaleString('fr-FR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  }

  resultCarbon(ecv: number) {
    if (!this.impactPerTraveller) {
      return '0';
    }
    const value = this.impactPerTraveller / ecv;

    return value === 0
      ? '0'
      : value.toLocaleString('fr-FR', {
          minimumFractionDigits: 1,
          maximumFractionDigits: 2,
        });
  }

  get compareCar(): {
    name: string;
    ecv: string;
    icon: string;
    description: string;
    alt: string;
  }[] {
    return this._compareCar;
  }
}
